webpackJsonp([2556497128042],{

/***/ 437:
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"postBySlug": {
				"html": "<p>Flutter is a mobile sdk that, at its core, is fundamentally about empowering\neveryone to build beautiful mobile apps. Whether you come from the world of\nweb development or native mobile development, Flutter makes it easy to create\nmobile apps in a familiar, simplified way -- without ever giving up control\nto the framework.</p>\n<p>Flutter is about the easiest thing to pick up as your first framework\nor coming from any other background. In fact, that’s how I’ve found\nmyself here, writing this post. I had to learn Flutter because of my job, and\nI loved it from the moment I started. I effectively became a mobile developer\novernight, because Flutter felt so familiar to my web development background.\n(In fact, the Flutter team has openly stated being influenced by ReactJS.)</p>\n<p>Flutter isn’t only about being easy, though. It’s also about control, and\nthat’s where ‘interesting’ turns into ‘exciting’. You can create exceptional\nmobile apps with Flutter with a pretty shallow knowledge of the framework. But\nyou can also create incredible and unique features, if you so choose, because\nFlutter exposes everything to the developer.</p>",
				"frontmatter": {
					"title": "About Flutter"
				},
				"fields": {
					"slug": "/about-flutter"
				}
			}
		},
		"pathContext": {
			"slug": "/about-flutter"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---about-flutter-730e8ebddb3b37c9dca0.js